import { useNavigate } from '@tanstack/react-router';
import { ServiceSelector } from '../../../../components/service-selector/service-selector';
import { useSchedulingLocationInfo } from '../../../../hooks/use-scheduling-location-info';

export const FindAvailabilityButton = () => {
  const navigate = useNavigate();
  const { selectedLocationIds, selectedOrgId } = useSchedulingLocationInfo();
  const locationId = selectedLocationIds[0] ?? '';

  return (
    <ServiceSelector
      locationId={locationId}
      orgId={selectedOrgId ?? ''}
      placement='bottom-end'
      leadingIcon='search-small'
      useNameLabel={false}
      onSelect={(appointmentTypeId) => {
        navigate({ to: '/schedule/availability', search: { appointmentTypeId } });
      }}
    />
  );
};
